import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const configs = {
  "cd.tnk.la": {
    apiKey: "AIzaSyACXNohUE88qpIw2C-edloNklO7Vw-EamA",
    authDomain: "tank-59802.firebaseapp.com",
    databaseURL: "https://tank-59802-default-rtdb.firebaseio.com",
    projectId: "tank-59802",
    storageBucket: "tank-59802.appspot.com",
    messagingSenderId: "210895005986",
    appId: "1:210895005986:web:20b88f1d81442cff219d7b",
  },
  "jd.tnk.la": {
    apiKey: "AIzaSyCSy_0DJlDOPyjhCe43P9w6DqHKOE7mNjk",
    authDomain: "jammerdefense.firebaseapp.com",
    databaseURL: "https://jammerdefense-default-rtdb.firebaseio.com",
    projectId: "jammerdefense",
    storageBucket: "jammerdefense.firebasestorage.app",
    messagingSenderId: "313434234206",
    appId: "1:313434234206:web:f785d9d8af1b15398103cf",
    measurementId: "G-DBRG5HKRFT",
  },
};

// En desarrollo local (localhost) usa CarDefense por defecto
const hostname = window.location.hostname;
const activeConfig = configs[hostname] ?? configs["cd.tnk.la"];

const app = initializeApp(activeConfig);

// App secundaria: solo se usa para autenticar contra la otra plataforma
// (login dual en AuthContext). No expone Firestore.
const secondaryKey = hostname === "jd.tnk.la" ? "cd.tnk.la" : "jd.tnk.la";
const appSecondary = initializeApp(configs[secondaryKey], "secondary");

export const auth = getAuth(app);
export const authSecondary = getAuth(appSecondary);

export const db = getFirestore(app);

// Indica qué plataforma está activa — úsalo para lógica condicional
// en queries (nombres de colecciones, campos, etc.)
// "cd" = CarDefense | "jd" = JammerDefense
export const platform = hostname === "jd.tnk.la" ? "jd" : "cd";

export default app;
